import { IEditPropertyProps } from './IEditPropertyProps';
import * as React from 'react';
import { FunctionComponent, useState } from 'react';
import { EditValueGrid } from './EditValueGrid';
import { AplixDropdown } from '../../../../components';

export const EditSelectionValue: FunctionComponent<IEditPropertyProps> = (props) => {
    const { save, property, validateRequired} = props;
    
    const [value, setValue] = useState<string | null>(property.value);

    const isValid = !validateRequired || !property.isRequired || (!!value);

    const submit = () => {
        save(value);
    };

    return (
        <EditValueGrid save={submit} isValid={isValid} property={property}>
            <AplixDropdown
                selectableValues={property.selectableValues}
                value={value}
                label={property.label}
                required={validateRequired && property.isRequired}
                onChange={setValue}
            />
        </EditValueGrid>
    );
};
